export default "__VITE_ASSET__1d8ddc67__"